import { gql } from '@apollo/client';

export const GET_TICKETS = gql`
  query GET_TICKETS($incidentId: ID!, $originatorId: ID!){
    getTickets(incidentId: $incidentId, originatorId: $originatorId) {
      id
      ticketNumber
      issuedTo {
        id
      }
      vehicle {
        id
      }
    }
  }
`;


export const GET_VEHICLE_INCIDENT_SPECIFICS = gql`
  query GET_VEHICLE_INCIDENT_SPECIFICS($incidentId: ID!, $originatorId: ID!){
    getVehicleIncidentSpecifics(incidentId: $incidentId, originatorId: $originatorId) {
      id
      vehicle {
        id
        uuid
      }
    }
  }
`;